export default __webpack_public_path__ + "static/media/hasjira.c26e7edc.svg";